/* eslint-disable jsx-a11y/anchor-is-valid */
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useTramite } from "../context/Tramite";

import "./css/components.css";
import {
  buscarUnidad,
  listarContaminantes,
  listarDestinosVertido,
  listarPeriodicidadesVuelco,
  listarProveedores,
  listarSubcuencas,
  listarTiposMuestreo,
} from "../api/General";
import { useCatalog } from "../context/Catalog";
import { crearLineaVertido } from "../utils/data";
import { isInvalid } from "../utils/forms";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import QuestionField from "./controls/QuestionField";
import AmmountField from "./controls/AmmountField";
import ArrayField from "./controls/ArrayField";

import { LineaVertidoForm } from "./LineaVertidoForm";
import { LineaVertidoList } from "./LineaVertidoList";

export default function DestinoEfluentesForm({ ...props }) {
  const { tramite } = useTramite();
  const { t } = useTranslation();
  const tramiteForm = useFormikContext();
  const unidadM3H = useCatalog(["unidad", "M3H"], () => buscarUnidad("M3H"));
  const unidadM3DIA = useCatalog(["unidad", "M3DIA"], () =>
    buscarUnidad("M3DIA"),
  );
  const unidadM3SEM = useCatalog(["unidad", "M3SEM"], () =>
    buscarUnidad("M3SEM"),
  );
  const unidadM3MES = useCatalog(["unidad", "M3MES"], () =>
    buscarUnidad("M3MES"),
  );
  const unidadM3ANIO = useCatalog(["unidad", "M3ANIO"], () =>
    buscarUnidad("M3ANIO"),
  );
  const unidadHDIA = useCatalog(["unidad", "HDIA"], () =>
    buscarUnidad("HDIA"),
  );
  const unidadHSEM = useCatalog(["unidad", "HSEM"], () =>
    buscarUnidad("HSEM"),
  );
  const unidadHMES = useCatalog(["unidad", "HMES"], () =>
    buscarUnidad("HMES"),
  );
  const unidadHANIO = useCatalog(["unidad", "HANIO"], () =>
    buscarUnidad("HANIO"),
  );
  const unidadH = useCatalog(["unidad", "H"], () => buscarUnidad("H"));
  const unidadPorcentaje = useCatalog(["unidad", "PORCENTAJE"], () =>
    buscarUnidad("PORCENTAJE"),
  );
  const prestadoresCatalog = useCatalog(["proveedores"], () =>
    listarProveedores(null),
  );
  const subcuencasCatalog = useCatalog(["subcuencas"], () =>
    listarSubcuencas(null),
  );
  const destinosVertidoCatalog = useCatalog(["destinosVertido"], () =>
    listarDestinosVertido(null),
  );
  const periodicidadesCatalog = useCatalog(["periodicidadesVuelco"], () =>
    listarPeriodicidadesVuelco(null),
  );
  const contaminantesCatalog = useCatalog(
    ["contaminantes", "LIQUIDO"],
    () => listarContaminantes({ estado: "LIQUIDO" }),
  );
  const tiposMuestreoCatalog = useCatalog(["tiposMuestreo"], () =>
    listarTiposMuestreo({}),
  );
  const loading =
    unidadM3H.loading ||
    unidadM3DIA.loading ||
    unidadM3SEM.loading ||
    unidadM3MES.loading ||
    unidadM3ANIO.loading ||
    unidadHDIA.loading ||
    unidadHSEM.loading ||
    unidadHMES.loading ||
    unidadHANIO.loading ||
    unidadH.loading ||
    unidadPorcentaje.loading ||
    prestadoresCatalog.loading ||
    subcuencasCatalog.loading ||
    destinosVertidoCatalog.loading ||
    periodicidadesCatalog.loading ||
    contaminantesCatalog.loading ||
    tiposMuestreoCatalog.loading;
  const handleConTratamientoExternoChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleReusoTratamientoChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleLineasVertidoChange = (event) => {
    tramiteForm.handleChange(event);
  };
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col>
            <QuestionField
              id="conTratamientoExterno"
              name="conTratamientoExterno"
              label={t("tramite.conTratamientoExterno")}
              value={tramiteForm.values.conTratamientoExterno}
              onChange={handleConTratamientoExternoChange}
              isInvalid={isInvalid("conTratamientoExterno", tramiteForm)}
              error={t(tramiteForm.errors.conTratamientoExterno)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={4}>
            <AmmountField
              id="reusoTratamiento"
              name="reusoTratamiento"
              label={t("tramite.reusoTratamiento")}
              value={tramiteForm.values.reusoTratamiento}
              onChange={handleReusoTratamientoChange}
              unit={unidadPorcentaje.data}
              isInvalid={isInvalid("reusoTratamiento", tramiteForm)}
              error={t(tramiteForm.errors.reusoTratamiento)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrayField
              id="lineasVertido"
              name="lineasVertido"
              label={t("tramite.lineasVertido")}
              value={tramiteForm.values?.lineasVertido}
              onChange={handleLineasVertidoChange}
              createItem={crearLineaVertido}
              isInvalid={isInvalid("lineasVertido", tramiteForm)}
              error={
                (tramiteForm.errors.lineasVertido instanceof Array &&
                  t("errors.tramite.lineasVertido.many")) ||
                t(tramiteForm.errors.lineasVertido)
              }
              disabled={!isEditable(tramite)}
            >
              {({
                value: lineasVertido,
                append,
                remove,
                replace,
                select,
                selectedIndex,
                selectedItem,
                disabled,
              }) => (
                <Grid>
                  {!disabled && (
                    <Row>
                      <Col>
                        <LineaVertidoForm
                          value={selectedItem}
                          page={selectedIndex}
                          pages={lineasVertido.length}
                          select={select}
                          append={append}
                          replace={replace}
                          remove={remove}
                          destinosVertido={destinosVertidoCatalog.data}
                          contaminantes={contaminantesCatalog.data}
                          periodicidadesVuelco={periodicidadesCatalog.data}
                          prestadores={prestadoresCatalog.data}
                          subcuencas={subcuencasCatalog.data}
                          tiposMuestreo={tiposMuestreoCatalog.data}
                          unidadPeriodoMuestreo={unidadH.data}
                          unidadCaudalMedio={unidadM3H.data}
                          unidadCaudalMedioDiario={unidadM3DIA.data}
                          unidadCaudalMedioDiscontinuo={unidadM3ANIO.data}
                          unidadCaudalMedioMensual={unidadM3MES.data}
                          unidadCaudalMedioSemanal={unidadM3SEM.data}
                          unidadCaudalPico={unidadM3H.data}
                          unidadCaudalTeorico={unidadM3DIA.data}
                          unidadHorasVuelcoDiario={unidadHDIA.data}
                          unidadHorasVuelcoDiscontinuo={unidadHANIO.data}
                          unidadHorasVuelcoMensual={unidadHMES.data}
                          unidadHorasVuelcoSemanal={unidadHSEM.data}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <LineaVertidoList
                        value={lineasVertido}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
